import { useAtomValue } from 'jotai';
import React__default, { useState, useCallback } from 'react';
import { mfaSmsVerificationIdAtom, mfaSmsPhoneNumberAtom } from '../../atoms/mfaSmsAtoms.js';
import { useAuthContext } from '../../providers/AuthContext.js';
import { MfaSmsCodeInput } from './MfaSmsCodeInput.js';
import { MfaSmsPhoneInput } from './MfaSmsPhoneInput.js';
import { ReauthPopup } from './ReauthPopup.js';

/**
 * SMS verification component
 * Coordinates phone number input and code verification steps
 * Handles re-authentication popup for both steps when session expires
 */
function MfaSms({ onEnrollmentComplete, onForgotPassword, codeStepTitle, codeStepDetails, }) {
    const { authService } = useAuthContext();
    const verificationId = useAtomValue(mfaSmsVerificationIdAtom);
    const phoneNumber = useAtomValue(mfaSmsPhoneNumberAtom);
    const [showReauthPopup, setShowReauthPopup] = useState(false);
    const [onReauthSuccess, setOnReauthSuccess] = useState(null);
    /**
     * Called by child components when requires-recent-login error occurs.
     * Shows the reauth popup and stores the retry callback.
     */
    const handleRequiresRecentLogin = useCallback((retryCallback) => {
        // Store callback as a function that returns the callback (to avoid React treating it as an updater)
        setOnReauthSuccess(() => retryCallback);
        setShowReauthPopup(true);
    }, []);
    /**
     * Check if an error is a requires-recent-login error.
     * Passed to children so they can detect when to trigger reauth.
     */
    const checkRequiresRecentLogin = useCallback((error) => {
        return authService.isRequiresRecentLoginError(error);
    }, [authService]);
    const handleReauthPopupChange = useCallback((open) => {
        setShowReauthPopup(open);
        if (!open) {
            setOnReauthSuccess(null);
        }
    }, []);
    const handleReauthSuccess = useCallback(() => {
        if (onReauthSuccess) {
            onReauthSuccess();
        }
    }, [onReauthSuccess]);
    return (React__default.createElement(React__default.Fragment, null,
        verificationId && phoneNumber ? (React__default.createElement(MfaSmsCodeInput, { onRequiresRecentLogin: handleRequiresRecentLogin, checkRequiresRecentLogin: checkRequiresRecentLogin, onEnrollmentComplete: onEnrollmentComplete, codeStepTitle: codeStepTitle, codeStepDetails: codeStepDetails })) : (React__default.createElement(MfaSmsPhoneInput, { onRequiresRecentLogin: handleRequiresRecentLogin, checkRequiresRecentLogin: checkRequiresRecentLogin })),
        React__default.createElement(ReauthPopup, { isOpen: showReauthPopup, onOpenChange: handleReauthPopupChange, onSuccess: handleReauthSuccess, onForgotPassword: onForgotPassword })));
}

export { MfaSms };
//# sourceMappingURL=MfaSms.js.map
